import {
  ExtendedVCenter,
  GroupMetadata,
  EnvironmentRequestProduct
} from 'vrlcm-gui-types';
import * as Constants from '../../../constants/action-constants';
import { ADD_COLLECTOR_GROUP_DISPLAY_METADATA } from '../../../constants/action-constants';
import { DisplayGroupMetadata } from '../../../types/Common';
import {
  ProductDisplayMetadata,
  ProductMetadata
} from '../../../types/workflows/steps/Product';
export interface InitializeStepProducts {
  type: Constants.INITIALIZE_STEP_PRODUCTS;
}

export interface InitializeStepProductsSuccess {
  type: Constants.INITIALIZE_STEP_PRODUCTS_SUCCESS;
  payload: {
    products: any[];
    vCenters: ExtendedVCenter[];
    existingVidm?: EnvironmentRequestProduct;
    productsMetadata: ProductMetadata[];
    productsDisplayMetadata: ProductDisplayMetadata[];
    vropsLogForwardingEntities: string[];
  };
}

export interface InitializeStepProductsFailed {
  type: Constants.INITIALIZE_STEP_PRODUCTS_FAILED;
}

export interface DestroyStepProducts {
  type: Constants.DESTROY_STEP_PRODUCTS;
}

export interface AddProductNode {
  type: Constants.ADD_PRODUCT_NODE;
  payload: {
    productId: string;
    nodeMetadata: GroupMetadata;
    displayMetadata: DisplayGroupMetadata;
  };
}

export interface DeleteProductNode {
  type: Constants.DELETE_PRODUCT_NODE;
  payload: {
    productId: string;
    nodeIndex: number;
  };
}

export interface AddCollectorGroupDisplayMetadata {
  type: Constants.ADD_COLLECTOR_GROUP_DISPLAY_METADATA;
  payload: {
    displayMetadata: DisplayGroupMetadata;
  };
}

export type StepProductsAction =
  | InitializeStepProducts
  | InitializeStepProductsFailed
  | InitializeStepProductsSuccess
  | DestroyStepProducts
  | AddProductNode
  | DeleteProductNode
  | AddCollectorGroupDisplayMetadata;

export const initializeStepProducts = (): InitializeStepProducts => ({
  type: Constants.INITIALIZE_STEP_PRODUCTS
});

export const initializeStepProductsSuccess = (
  products: any[],
  vCenters: ExtendedVCenter[],
  productsMetadata: ProductMetadata[],
  productsDisplayMetadata: ProductDisplayMetadata[],
  vropsLogForwardingEntities: string[],
  existingVidm?: EnvironmentRequestProduct
): InitializeStepProductsSuccess => ({
  payload: {
    products,
    vCenters,
    existingVidm,
    productsMetadata,
    productsDisplayMetadata,
    vropsLogForwardingEntities
  },
  type: Constants.INITIALIZE_STEP_PRODUCTS_SUCCESS
});

export const initializeStepProductsFailed = (): InitializeStepProductsFailed => ({
  type: Constants.INITIALIZE_STEP_PRODUCTS_FAILED
});

export const destroyStepProducts = (): DestroyStepProducts => ({
  type: Constants.DESTROY_STEP_PRODUCTS
});

export const addProductNode = (
  productId: string,
  nodeMetadata: GroupMetadata,
  displayMetadata: DisplayGroupMetadata
): AddProductNode => ({
  type: Constants.ADD_PRODUCT_NODE,
  payload: { productId, nodeMetadata, displayMetadata }
});

export const deleteProductNode = (
  productId: string,
  nodeIndex: number
): DeleteProductNode => ({
  type: Constants.DELETE_PRODUCT_NODE,
  payload: { productId, nodeIndex }
});

export const addCollectorGroupDisplayMetadata = (
  displayMetadata: DisplayGroupMetadata
): AddCollectorGroupDisplayMetadata => ({
  type: ADD_COLLECTOR_GROUP_DISPLAY_METADATA,
  payload: {
    displayMetadata
  }
});
